export const GET_CITIES = 'GET_CITIES';
export const GET_CITIES_LOADING = 'GET_CITIES_LOADING';
export const GET_CITIES_ERROR = 'GET_CITIES_ERROR';

export const GET_CITIES_BY_ID = 'GET_CITIES_BY_ID';
export const GET_CITIES_BY_ID_LOADING = 'GET_CITIES_BY_ID_LOADING';
export const GET_CITIES_BY_ID_ERROR = 'GET_CITIES_BY_ID_ERROR';

export const UPDATE_CITY_PET_POINT = 'UPDATE_CITY_PET_POINT';
export const UPDATE_CITY_PET_POINT_LOADING = 'UPDATE_CITY_PET_POINT_LOADING';
export const UPDATE_CITY_PET_POINT_ERROR = 'UPDATE_CITY_PET_POINT_ERROR';
export const UPDATE_CITY_PET_POINT_RESET_STATE = 'UPDATE_CITY_PET_POINT_RESET_STATE';

export const UPDATE_CURRENCY = 'UPDATE_CURRENCY';
export const UPDATE_CURRENCY_LOADING = 'UPDATE_CURRENCY_LOADING';
export const UPDATE_CURRENCY_ERROR = 'UPDATE_CURRENCY_ERROR';
export const UPDATE_CURRENCY_RESET_STATE = 'UPDATE_CURRENCY_RESET_STATE';

export const UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD';
export const UPDATE_PAYMENT_METHOD_LOADING = 'UPDATE_PAYMENT_METHOD_LOADING';
export const UPDATE_PAYMENT_METHOD_ERROR = 'UPDATE_PAYMENT_METHOD_ERROR';
export const UPDATE_PAYMENT_METHOD_RESET_STATE = 'UPDATE_PAYMENT_METHOD_RESET_STATE';
